import { render } from "./classic-inputs.vue?vue&type=template&id=56fe3132&lang=pug"
import script from "./classic-inputs.vue?vue&type=script&lang=js"
export * from "./classic-inputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__